import { cn } from "@/lib/utils";
import { motion } from "motion/react";
export const Loader = ({ className = "" }: { className?: string }) => {
  return (
    <motion.div
      variants={loaderVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className={cn(
        "relative flex h-full w-full items-center justify-center",
        className
      )}
    >
      <div className="loader relative" />
    </motion.div>
  );
};

const loaderVariants = {
  initial: {
    opacity: 0,
    scale: 0.2,
  },
  animate: {
    opacity: 1,
    scale: 1,
  },
  exit: {
    opacity: 0,
    scale: 2,
  },
};
